{
  "login-secret-with-pin-page": {
    "buttons": {
      "resend": "Znovu odeslat",
      "submit": "Odeslat"
    },
    "text": {
      "in-second": "v {{seconds}} s",
      "pin-email-invalid": "PIN je nesprávný. Zkontrolujte jej prosím ve svém e-mailu a zkuste to znovu.",
      "pin-sms-invalid": "PIN je nesprávný. Zkontrolujte jej prosím v SMS a zkuste to znovu.",
      "resend-pin-hint": "Neobdrželi jste žádný PIN?",
      "verify-email": "Ověření e-mailu",
      "verify-phone-nr": "Ověření telefonního čísla",
      "verify-update": "Ověření aktualizace",
      "verify-update-by-email": "Potvrzovací pin obdržíte e-mailem",
      "verify-update-by-sms": "Potvrzovací pin obdržíte prostřednictvím SMS"
    }
  }
}
